/**
 *
 * FreshPets Ratios
 *
 */

const ratios = [0.05, 0.125, 0.25, 0.5, 0.75]

export default ratios
